// TPP Core: home behaviour. Presentation only; respect prefers-reduced-motion.
// Staggered fade-up for row items (quote cards, USP row). Content is fully visible without JS or with reduced motion.
(function () {
  if (window.__tppHome) return;
  window.__tppHome = true;
  if (document.body.className.indexOf('template-suffix-') !== -1 && !document.body.classList.contains('template-suffix-cro')) return; // main homepage + CRO alternate only
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const groups = ['.section-logo-list .logo-list__logo', '.ct-usps .ct-usp'];
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });

  const fold = window.innerHeight;
  groups.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el, i) => {
      if (el.getBoundingClientRect().top < fold) return; // never hide something already on screen
      el.classList.add('home-rvl');
      el.style.transitionDelay = (i % 5) * 70 + 'ms';
      io.observe(el);
    });
  });
})();
